import {
  APPLICATION_FETCHED, APPLICATIONS_FETCHED, APPLICATIONS_FILTERED
} from 'utils/constants'

export default (state = {}, action) => {
  switch (action.type) {
    case APPLICATION_FETCHED: {
      return { ...state, application: action.data.application };
    }
    case APPLICATIONS_FETCHED: {
      return { ...state, list: action.data.applications || [], filtered: [] };
    }
    case APPLICATIONS_FILTERED: {
      return { ...state, filtered: action.data.filteredApplications || []};
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/applications.js